export default "__VITE_ASSET__tW1BLptj__"